<template>
    <b-card :title="$translate('filters')" class="query-filter filter-form mt-3">
        <div>
            <b-row>
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label for="input-default-engineer-id" class="mb-3"><strong>{{ $translate('customer_agents')
                    }}</strong></label>
                    <b-form-select class="form-control" id="input-default-engineer-id"
                        v-model="filtersModel.customer_agent_id" value-field="id" text-field="agent_name"
                        :options="customerAgents">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('select_customer_agent')
                            }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label for="fieldset-role-id" class="mb-3"><strong>{{ $translate('customer_groups') }}</strong></label>
                    <b-form-select class="form-control" id="input-role-id" v-model="filtersModel.customer_group_id"
                        value-field="id" text-field="name" :options="customerGroups">
                        <template #first>
                            <b-form-select-option :value="null">{{ $translate('select_customer_group') }}</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label for="input-assetType" class="mb-3"><strong>{{ $translate('customer_segments') }}</strong></label>
                    <b-form-select class="form-control" id="input-assetType" v-model="filtersModel.customer_segment_id"
                        value-field="id" text-field="name" :options="customerSegments">
                        <template #first>
                            <b-form-select-option
                                :value="null">{{ $translate('select_customer_segment') }}</b-form-select-option>    
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mt-3 dd">
                    <label for="input-assetType" class="mb-3"><strong>{{ $translate('lifecycle_stage') }}</strong></label>
                    <b-form-select class="form-control" id="input-assetType" v-model="filtersModel.lifecycle_stage_id"
                        value-field="id" text-field="name" :options="lifecycleStages">
                        <template #first>
                            <b-form-select-option
                                :value="null">{{ $translate('select_lifecycle_stage') }}</b-form-select-option>    
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
        </div>
    </b-card>
</template>

<script>
// import CustomerTypeAhead from '@/components/CustomerTypeAhead'

export default {
    name: 'assets-reportQueryBuilder',
    data: () => ({}),
    props: ['value', 'customerSegments', 'customerGroups', 'customerAgents','lifecycleStages'],

    computed: {
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },
    },

    watch: {},
}
</script>
